var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('responsive-grid',{attrs:{"id":"resp-grid","search-results":true,"root-scroll-container":"search-scroll-container","flyer-pages":_vm.flyerPages}})}
var staticRenderFns = []

export { render, staticRenderFns }